import type { FaireProductEntity } from "../../entity_types/product";

export const p_zruenx3vb9: FaireProductEntity = {
  token: "p_zruenx3vb9",
  type: "product",
  name: "Olive Food-Shaped Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/14c32f3fafacfecf2eec53e1aa69a514772c2860d5d55383db1dd981d4f7ddc5.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description: "Serve up grocery lists, recipes, memos & more with our Olive Sticky Notes. This die-cut, olive-shaped pad features 50 writable, stickable sheets—perfect for staying organized, jotting reminders, leaving lunch notes, or bookmarking your favorite cookbooks.\n\nGood to know:\n\n * Stick & restick anywhere \n * Thick sticky pad with 50 sheets \n * Measures roughly 3\"x3\" \n * Packaged on a thick backing card and wrapped in a cellophane sleeve. \n * 100% recyclable 🍅 ",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:02.304Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
